import { Text } from "@mantine/core";

export default function TaskPage() {
  return <Text>Nothing here</Text>;
}
